import React, {useCallback, useMemo} from "react";
import {Link, useNavigate} from "react-router-dom";
import {Video} from "../../../../common/video/models/Video";
import {SceneHighlight} from "../../SearchResult";
import styles from "./SceneHighlightCard.module.css";
import {Label12, Label14, Text14, Text16} from "../../../../common/components/typography/Typography";
import {
    stringifyVideoTimeWithColons,
    stringifyVideoTimeWithLetters
} from "../../../../common/video/util/videoTimeStrings";
import {Highlight} from "./Highlight";
import useResponsive from "../../../../common/useResponsive";

interface SceneHighlightProps {
    video: Video;
    highlight: SceneHighlight;
}

export default function SceneHighlightCard({video, highlight}: SceneHighlightProps) {
    const history = useNavigate();
    const {isMobile} = useResponsive();

    const startLabel = stringifyVideoTimeWithColons(highlight.startMillis, true);

    const link = useMemo(() => {
        return `/video/${video.hash}?time=${stringifyVideoTimeWithLetters(highlight.startMillis)}`;
    }, [video, highlight]);

    const goToVideo = useCallback(() => history(link), [history, link]);

    return (
        <div className={styles.card} onClick={goToVideo}>
            <div className={styles.text}>
                <Link to={link}>
                    {isMobile ? (
                        <Label12 color="gray-42" variant="normal">
                            {startLabel}
                        </Label12>
                    ) : (
                        <Label14 color="gray-42" variant="normal">
                            {startLabel}
                        </Label14>
                    )}
                </Link>

                <div className={styles.highlight}>
                    {isMobile ? (
                        <Text14>
                            ...
                            <Highlight highlights={highlight.textHighlights}/>
                            ...
                        </Text14>
                    ) : (
                        <Text16 lineHeight={1.43}>
                            ...
                            <Highlight highlights={highlight.textHighlights}/>
                            ...
                        </Text16>
                    )}
                </div>
            </div>
        </div>
    );
}
